import React from "react";

type Prop = {
  ToggleHandler: () => void;
  Toggle: any;
};

function SupplierToggle(props: Prop) {
  return (
    <div className="flex items-center justify-center w-full mt-10">
      <label htmlFor="toggleB" className="flex items-center cursor-pointer">
        <div className="relative">
          <input
            type="checkbox"
            onClick={props.ToggleHandler}
            id="toggleB"
            className="sr-only"
          />
          <div className="block bg-cyan-100 w-52 h-10 rounded-full">
            <div className="flex flex-row justify-evenly pt-3">
              <p className="pr-8 text-xs font-semibold text-gray-900 font-Montserrat">
                Overview
              </p>
              <p className="pr-4 text-xs font-semibold text-gray-900 font-Montserrat">
                List
              </p>
            </div>
          </div>
          <div className="dot absolute left-2 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
            {props.Toggle == "Overview" ? <>Overview</> : <>List</>}
          </div>
        </div>
      </label>
    </div>
  );
}

export default SupplierToggle;
